export const initKrankmeldung = () => {
    const form = document.querySelector("form.krankmeldung");
    if (!form) {
        return;
    }
    const classesToHide = [
        "durationfrom",
        "durationto",
        "spaeter",
        "reason",
        "severeIllnessselect",
        "symptoms",
        "illnessType",
    ];
    const markLabelRequired = (field, required) => {
        var _a;
        let label = null;
        if (field.id) {
            label = form.querySelector(`label[for="${field.id}"]`);
        }
        if (!label) {
            const group = field.closest(".form-group");
            label = (_a = group === null || group === void 0 ? void 0 : group.querySelector("label")) !== null && _a !== void 0 ? _a : null;
        }
        if (!label) {
            return;
        }
        const requiredMarker = label.querySelector(".required-marker");
        if (required) {
            if (!requiredMarker) {
                const marker = document.createElement("span");
                marker.className = "required-marker";
                marker.textContent = " *";
                label.appendChild(marker);
            }
        }
        else if (requiredMarker) {
            requiredMarker.remove();
        }
    };
    const setRequiredState = (container, required) => {
        const fields = container.querySelectorAll("input, select, textarea");
        fields.forEach((field) => {
            if (required) {
                field.setAttribute("required", "required");
            }
            else {
                field.removeAttribute("required");
            }
            markLabelRequired(field, required);
        });
    };
    const setVisibility = (className, visible) => {
        form.querySelectorAll(`.${className}`).forEach((el) => {
            el.style.display = visible ? "" : "none";
            setRequiredState(el, visible);
        });
    };
    const hideAll = () => {
        classesToHide.forEach((cls) => setVisibility(cls, false));
    };
    const hideIllnessDetails = () => {
        setVisibility("symptoms", false);
        setVisibility("illnessType", false);
    };
    const radios = form.querySelectorAll('input[name$="[radiobutton-1]"]');
    const severeIllnessRadios = form.querySelectorAll('input[name$="[radiobutton-2]"]');
    const updateSevereIllnessFields = () => {
        hideIllnessDetails();
        const checkedSevereIllness = form.querySelector('input[name$="[radiobutton-2]"]:checked');
        if (!checkedSevereIllness) {
            return;
        }
        const selectedValue = checkedSevereIllness.value.trim().toLowerCase();
        if (selectedValue === "ja") {
            setVisibility("illnessType", true);
        }
        else if (selectedValue === "nein") {
            setVisibility("symptoms", true);
        }
    };
    const updateFormByRadioValue = (value) => {
        hideAll();
        switch (value) {
            case "Kind kommt später":
                setVisibility("spaeter", true);
                setVisibility("reason", true);
                break;
            case "Kind kommt nicht":
                setVisibility("reason", true);
                setVisibility("durationfrom", true);
                setVisibility("durationto", true);
                break;
            case "Kind ist krank":
                setVisibility("severeIllnessselect", true);
                setVisibility("durationfrom", true);
                setVisibility("durationto", true);
                updateSevereIllnessFields();
                break;
        }
    };
    radios.forEach((radio) => {
        radio.addEventListener("change", () => {
            updateFormByRadioValue(radio.value);
        });
    });
    severeIllnessRadios.forEach((radio) => {
        radio.addEventListener("change", () => {
            const checkedMainRadio = form.querySelector('input[name$="[radiobutton-1]"]:checked');
            if ((checkedMainRadio === null || checkedMainRadio === void 0 ? void 0 : checkedMainRadio.value) === "Kind ist krank") {
                updateSevereIllnessFields();
            }
        });
    });
    const checkedMainRadio = form.querySelector('input[name$="[radiobutton-1]"]:checked');
    if (checkedMainRadio) {
        updateFormByRadioValue(checkedMainRadio.value);
    }
    else {
        hideAll();
    }
};
